import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { getProfile } from 'services/redux/auth/login/action';
import { GET_PROFILE } from 'services/redux/auth/login/type';
import {DISTANCE_DETAILS, ENG_DISTANCE_DATA, SITE_DATA, DISTANCE_DAILY_TASK} from "./type";
import { pickDistanceRow } from 'services/attendance/siteCheckout';

export const getSiteData = (siteId) => async (dispatch) => {
    dispatch({
        type: SITE_DATA,
        payload: null,
    });
    const res = await callWebService(
        callTypes.get,
        '',
        Config.distanceCalculator.siteData+"?site_id="+siteId
    );
    if (res?.data?.response?.status === true) {
        const { data } = res;
        const sitePayload = data?.response?.data ?? null;
        localStorage.setItem("distance_cal_site_data", JSON.stringify(sitePayload));
        dispatch({
            type: SITE_DATA,
            payload: sitePayload,
        });
        return sitePayload;
    }
    return null;
};

export const calculateDistance = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.distanceCalculator.calculateDistance}`
    );

    // Go backend success: { status: 0, message, data: { id, site_id, ... } }
    if (res?.data?.status === 0) {
        dispatch({
            type: ENG_DISTANCE_DATA,
            payload: res.data.data,
        });
        dispatch(getProfile());
        return true;
    }

    // Legacy Laravel success: { response: { status: true, data: {...} } }
    if (res?.data?.response?.status === true) {
        dispatch({
            type: ENG_DISTANCE_DATA,
            payload: res.data.response.data,
        });
        dispatch(getProfile());
        return true;
    }

    // 409 Conflict — CTE ticket: handled via confirm dialog in Calculator.js (no toast).
    const conflictBody = res?.data;
    if (
        data?.module_type === 'cte_ticket' &&
        conflictBody?.data?.active_checkin_id
    ) {
        return { conflict: true, data: conflictBody.data };
    }

    return res?.data?.response;
};

export const getDistanceData = (siteId, module_type, ticketId = null, activeOnly = false) => async (dispatch) => {
    let url = Config.distanceCalculator.distanceCalculateData + "?site_id=" + (siteId || '') + "&module_type=" + module_type;
    if (ticketId) {
        url += "&ticket_id=" + ticketId;
    }
    if (activeOnly) {
        url += "&active=1";
    }
    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    // Go backend success: { status: 0, message, data: [...] }
    if (res?.data?.status === 0) {
        const payload = pickDistanceRow(res.data.data, ticketId);
        dispatch({ type: DISTANCE_DETAILS, payload });
        return payload;
    }
    // Legacy Laravel fallback
    if (res?.data?.response?.status === true) {
        const payload = pickDistanceRow(res.data.response.data, ticketId);
        dispatch({ type: DISTANCE_DETAILS, payload });
        return payload;
    }
    return res;
};

/** After rmCheckOut: refresh distance row + profile so DutyBar drops the visit. */
export const refreshAfterSiteCheckout = (siteId, moduleType = 'site_stage') => async (dispatch, getState) => {
  dispatch({ type: DISTANCE_DETAILS, payload: {} });
  if (siteId) {
    await dispatch(getDistanceData(siteId, moduleType));
  }
  await dispatch(getProfile());

  const profile = getState()?.loginReducer?.userProfile || {};
  const active = profile.active_distance_checkin;
  if (
    active &&
    siteId != null &&
    String(active.site_id) === String(siteId)
  ) {
    dispatch({
      type: GET_PROFILE,
      payload: { ...profile, active_distance_checkin: null },
    });
  }
};

export const getDistanceDataDailyTaskAtt = (siteId, page = 1) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        Config.distanceCalculator.distanceCalculateDataAtt+"?site_id="+siteId+"&page="+page
    );
    if (res?.data?.response?.status === true) {
        const { data } = res;
        localStorage.setItem("distance_cal_site_data", JSON.stringify(data?.response?.data));
        dispatch({
            type: DISTANCE_DAILY_TASK,
            payload: data?.response?.data,
        });
    } else {
        return res;
    }
};

export const generateHappyCodePM = (scheduledId) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.maintenance.generateHappyCodePM}?scheduled_id=${scheduledId}`
    );
    if (res) {
      return true;
    }
};